import { BrandLogo } from './BrandLogo';
import tuvSudLogoSrc from '../../assets/tuvsud_logo.png';

interface TuvSudLogoProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
  variant?: 'full' | 'compact';
}

export function TuvSudLogo({ width = 120, height, className, style, variant = 'full' }: TuvSudLogoProps) {
  void variant;
  const resolvedHeight = height ?? Math.round((width * 154) / 149);

  return (
    <BrandLogo
      src={tuvSudLogoSrc}
      alt="TÜV SÜD"
      width={width}
      height={resolvedHeight}
      className={className}
      style={style}
    />
  );
}
